import { createClient } from '@prismicio/client';
import { useQuery } from 'react-query';

// const PRISMIC_URL = 'https://oelpstg.prismic.io/api/v2'; // NOTE: staging url (use for development)
const PRISMIC_URL = 'https://learningplatform.prismic.io/api/v2';
const client = createClient(PRISMIC_URL, {
  defaultParams: {
    lang: '*',
  },
  fetch: (url, options) => fetch(url, options),
});

export function usePrismicQuery(query: string | string[]) {
  const { data, isLoading } = useQuery(
    ['prismic', query],
    () => client.get({ predicates: query }),
    {
      enabled: !!query,
    }
  );

  return {
    results: data?.results,
    isLoading,
  };
}
